import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { mediaQuery } from 'lib/styledSystem/mediaQuery';

export const HEADER_HEIGHT = '60px';
export const FILTER_HEADER_HEIGHT = '114px';
export const MAP_PADDING = '10px';

export const FixedPageWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${themeGet('zIndices.mapsPage')};
  background: ${themeGet('colors.greys.porcelain')};

  display: flex;
  flex-direction: column;
`;

export const MapUtilitiesWrapper = styled.header`
  flex: 0 0 ${HEADER_HEIGHT};
  top: ${HEADER_HEIGHT};
  display: flex;
  justify-content: left;
  align-items: left;
  background: ${themeGet('colors.white')};
  padding: 5px 10px;
  border-bottom: 1px solid ${themeGet('colors.greys.alto')};

  ${mediaQuery.minWidth.sm} {
    flex-basis: 54px;
  }
`;

export const MapWrapper = styled.div`
  flex: 1 1 100%;
  position: relative;
`;
